module.exports = __webpack_public_path__ + "img/crm_double_check.d0ca902e.png";